import React, { useState } from "react";
import styled from "styled-components";
import ByPlanWithRegion from "./Trials/byPlanWithRegion"
import ByAccountTypeWithRegion from "./Trials/byAccountTypeWithRegion";

function TotalTrialsWithRegionExplorer() {
  const [searchBy, setSearchBy] = useState("dd"); // 'week' or 'dd'
  const currentDateLabel = searchBy === "dd" ? "Daily" : "Weekly";
  const inverseDateLabel = searchBy === "dd" ? "Weekly" : "Daily";

  const handleChangeTimeFrame = () => {
    setSearchBy(searchBy === "dd" ? "week" : "dd");
  };

  return (
    <Container>
      <h1>
        Trials by plan and account type
      </h1>
      <div>
        <label>Current Time Frame:</label>&nbsp;
        <span style={{ fontSize: "1.2rem" }}>{currentDateLabel}</span> &nbsp;
        <button onClick={handleChangeTimeFrame}>Change to {inverseDateLabel}</button>
      </div>
      <br />
      <h2>{currentDateLabel} by Plan with region</h2>
      <ByPlanWithRegion date={searchBy} />
      <hr />

      <br />
      <h2>{currentDateLabel} by Account type with region</h2>
      <ByAccountTypeWithRegion date={searchBy} />
      <hr />
    </Container>
  );
}

const Container = styled.div`
  width: 80%;
  margin:24px auto;
  .iReLkr .ReactTable * {
    text-align:left
  }
`;


export default TotalTrialsWithRegionExplorer